module.exports = __webpack_public_path__ + "static/media/about2.c249b809.jpg";